
import CloseIcon from '@mui/icons-material/Close';
import {AppBar, Button, Dialog, FormControlLabel, IconButton, Radio, RadioGroup, Toolbar} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';

import usePostRequest from '../../hooks/usePostRequest';
import { buttonStyles, buttonStylesGreen } from '../docsAdministrative/JsObjectStyles';
import { TextFieldComponent, Transition } from '../shared/ReusableSmallComponents';

const reasons = [
    { label: 'Dépasse le budget', value: 'Dépasse le budget' },
    { label: 'Ne répond pas aux exigences du projet', value: 'Ne répond pas aux exigences du projet' },
    { label: 'Autres', value: 'other' },
];

function DialogRejeteCandidature({aoId,dossierId, expertId,statusCandidature,openNestedRejetCandidature,
    handleCloseNestedRejetCandidature}) {
    DialogRejeteCandidature.propTypes = {
        aoId: PropTypes.any,
        dossierId: PropTypes.any,
        expertId: PropTypes.any,
        statusCandidature: PropTypes.any,
        openNestedRejetCandidature: PropTypes.any,
        handleCloseNestedRejetCandidature: PropTypes.func,
    };
    //! hooks rule : call a hook only inside a functionnal component, don't try to create a function to prevent DRY ..
    const { postData } = usePostRequest();
    const [selectedReason, setSelectedReason] = useState('');
    const { i18n } = useTranslation();
    const handleChange = (event) => {
        setSelectedReason(event.target.value);
    };
    //const [reason1Checked, setReason1Checked] = useState(false);
    //const [reason2Checked, setReason2Checked] = useState(false);
    //const [autreMotifChecked, setAutreMotifChecked] = useState(false);
    const [motifRejetManual, setMotifRejetManual] = useState('');

    const getFullMotifRejet = () => {
        if(selectedReason === 'other'){
            return motifRejetManual;
        }
        return selectedReason;
    };
    const RejeterCandidature = async () => {
        postData({ url: '/candidature/updateCandidatureStatus', payload:  {
            expertId,
            statusCandidature,
            // * AO context
            aoId,
            // * dossier context
            dossierId,
            motifRejet: getFullMotifRejet()
        } });
        handleCloseNestedRejetCandidature();
    };

    return (
        <Dialog
            open={openNestedRejetCandidature}
            onClose={handleCloseNestedRejetCandidature}
            TransitionComponent={Transition}
            fullScreen
            scroll={'paper'}
            PaperProps={{
                style: {
                    background: 'white',
                },
            }}
            aria-labelledby="scroll-dialog-title"
            aria-describedby="scroll-dialog-description"
        >
            <AppBar>
                <Toolbar>
                    <IconButton
                        edge="start"
                        color="inherit"
                        onClick={handleCloseNestedRejetCandidature}
                        aria-label="close"
                    >
                        <CloseIcon />
                        {selectedReason}
                    </IconButton>
                </Toolbar>
            </AppBar>
            <div style={{display:'flex',flexDirection:'row',justifyContent:'center',paddingTop: '170px',minHeight:'900px'}}>

                <div
                    className='createalertediv'
                    style={{width:'500px'}}
                >
                    <h4 className='titlesociete'>Motif du rejet</h4>
                    {/*<FormControlLabel
                        control={
                            //<Checkbox
                            <Radio
                                value={reason1Checked}
                                onChange={()=> setReason1Checked(!reason1Checked)}
                                // checked={true}
                                // id="ajouter"
                                // name="gender"
                            />
                        }
                        label="Dépasse le budget"
                    />
                    <FormControlLabel
                        control={
                            //<Checkbox
                            <Radio
                                value={reason2Checked}
                                onChange={()=> setReason2Checked(!reason2Checked)}
                            />
                        }
                        label="Ne répond pas aux exigences du projet"
                    />
                    <FormControlLabel
                        control={
                            //<Checkbox
                            <Radio
                                value={autreMotifChecked}
                                onChange={()=> setAutreMotifChecked(!autreMotifChecked)}
                            />
                        }
                        label="Autres"
                    />*/}
                    <RadioGroup
                        value={selectedReason}
                        onChange={handleChange}
                    >
                        {reasons.map((reason) => (
                            <FormControlLabel
                                key={reason.value}
                                control={<Radio />}
                                label={reason.label}
                                value={reason.value}
                            />
                        ))}
                    </RadioGroup>
                    {selectedReason === 'other' && (
                        <div className='rechercheposte2'>
                            <TextFieldComponent
                                name="motifRejet"
                                multiline
                                minRows={4}
                                value={motifRejetManual}
                                placeholder='A preciser... &#10;Tapez votre texte ici'
                                onChange={(e) => setMotifRejetManual(e.target.value)}
                                style={{width:'100%'}}
                                sx={{
                                    '& > :not(style)': { borderRadius: '8px'},
                                }}
                                //defaultValue=""
                                autoFocus={true}
                            />
                        </div>)}
                    <div className='btnstransmettrecv'>
                        <Button
                            className='cancelalerte'
                            style={{...buttonStyles()}}
                            onClick={handleCloseNestedRejetCandidature}
                        >{i18n.t('Annuler')}</Button>
                        <Button
                            type='submit'
                            style={{...buttonStylesGreen(false)}}
                            onClick={RejeterCandidature}
                        >Envoyer</Button>
                    </div>
                </div>
            </div>
        </Dialog>
    );
}

export default DialogRejeteCandidature;
